import { Text } from 'blaze-ui/Text/Text'
import { CreditUsageContentProps } from '../Types'

export const CreditUsageContent = ({ content }: CreditUsageContentProps) => {
  return (
    <Text variant="metadata" color="var(--dark-40)">
      This generation cost {content.credits_used} {content.credits_used === 1 ? 'credit' : 'credits'}
    </Text>
  )
}
